import { Brick, registerBrick, ErrorFlow, Transaction, QueryResult, BrickContext } from 'olympe';
import Picture from '../../../models/Picture';

export default class DeletePictureAndFile extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Picture} picture
     * @param {OFile} file
     * @param {Array | QueryResult} listOfPictures
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update($, [picture, file, listOfPictures], [forwardEvent, setErrorFlow]) {
        const transaction = new Transaction(true);
        transaction.delete(file);
        transaction.delete(picture);

        const filteredList = listOfPictures.filter(([pic]) => !pic.equals(picture));

        filteredList.forEach(([pic], index) => {
            transaction.update(pic, Picture.rankProp, index);
        });

        transaction
            .execute()
            .then(forwardEvent)
            .catch((e) => {
                setErrorFlow(ErrorFlow.create(`Failed to delete file: ${e}`, 0));
            });
    }
}

registerBrick('018a84240749f1f34253', DeletePictureAndFile);
